import ConfirmationModal from 'components/Modal/ConfirmationModal';
import React from 'react';
// import { ConfirmationModal } from 'components/modal/confirmationModal';

interface UnsavedTemplateChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  setNextTemplateToBeSelected: (template: any | null) => void; // eslint-disable-line @typescript-eslint/no-explicit-any
  onDiscard: () => void;
}

export const UnsavedTemplateChangesModal: React.FC<UnsavedTemplateChangesModalProps> = props => {
  const { isOpen, onClose, setNextTemplateToBeSelected, onDiscard } = props;

  const doNotDiscardTemplateChanges = () => {
    setNextTemplateToBeSelected(null);
    onClose();
  };

  const discardTemplateChanges = () => {
    onClose();
    onDiscard();
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onConfirm={discardTemplateChanges}
      onCancel={doNotDiscardTemplateChanges}
      title=""
      message="This template has unsaved changes, do you want to discard your changes?"
      confirmText="Yes, discard"
      cancelText="Continue editing"
    />
  );
};
